(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("CompanyApprovalPaymentLogList", CompanyApprovalPaymentLogList);

  CompanyApprovalPaymentLogList.$inject = [
    "$scope",
    "$state",
    "CompanyPaymentLog",
    "ParseLinks",
    "AlertService",
    "CompanyPaymentLogCustom",
    "QueryParamsService",
    "$mdDialog",
    "$uibModal"
  ];

  function CompanyApprovalPaymentLogList(
    $scope,
    $state,
    CompanyPaymentLog,
    ParseLinks,
    AlertService,
    CompanyPaymentLogCustom,
    QueryParamsService,
    $mdDialog,
    $uibModal
  ) {

    var vm = this;

    vm.filterQuery = {};
    vm.isSearching = false;
    vm.searchKeyPress = searchKeyPress;
    vm.clearSearch = clearSearch;
    vm.pageSizeChanged = pageSizeChanged;
    vm.transition = transition;
    vm.pageSizeList = [10, 20, 50];
    vm.size = 10;
    vm.page = 1;


    loadAll();

    function loadAll() {
      filterCompanyPaymentLogsInfo();
    }

    function filterCompanyPaymentLogsInfo(customFilter) {
      if (vm.isSearching) return;
      getQueryParams();
      getPaymentLogsPagesByQuery(customFilter);
    }
    function getQueryParams() {
      var newFilters = QueryParamsService.getFilters();
      // if(newFilters.page){
      //     vm.filterQuery.page = newFilters.page;
      //     vm.page = parseInt(newFilters.page);
      // }

      if (newFilters.page) {
        vm.filterQuery.page = parseInt(newFilters.page, 10) - 1;
        vm.page = parseInt(newFilters.page, 10);
      }

      if (newFilters.size) {
        vm.filterQuery.size = newFilters.size;
        vm.size = newFilters.size;
      }
      if (newFilters.query) {
        vm.filterQuery.query = newFilters.query;
      }
      if (newFilters["from-date"]) {
        vm.filterQuery["from-date"] = newFilters["from-date"];
      }
      if (newFilters["to-date"]) {
        vm.filterQuery["to-date"] = newFilters["to-date"];
      }
      if (newFilters["payment-type"]) {
        vm.filterQuery["payment-type"] = newFilters["payment-type"];
      }
      if (newFilters["approval-status"]) {
        vm.filterQuery["approval-status"] = newFilters["approval-status"];
      }
      if (newFilters["order-bag-id"]) {
        vm.filterQuery["order-bag-id"] = newFilters["order-bag-id"];
      }
      if (newFilters["invoice-id"]) {
        vm.filterQuery["invoice-id"] = newFilters["invoice-id"];
      }
      if (newFilters.filterQuery) {
        var newF = angular.extend(JSON.parse(decodeURIComponent(newFilters.filterQuery)), vm.filterQuery);
        // if (newF["order-bag-id"]) newF.orderBagId = newF["order-bag-id"];
        // if (newF["invoice-id"]) newF.invoiceId = newF["invoice-id"];
        setFilterQuery(newF);
      }
    }
    function getPaymentLogsPagesByQuery(customFilter) {
      if (vm.isSearching) return;

      vm.isSearching = true;
      var filterQ = vm.filterQuery;
      if (customFilter) filterQ = customFilter;

      if (vm.page) filterQ.page = vm.page - 1;
      else filterQ.page = 0;

      filterQ.size = vm.size;
      CompanyPaymentLogCustom.getCompanyPaymentLogList().query(filterQ).$promise.then(onSuccess, onError);

      // InvoiceInfoCustom.searchInvoiceInfoByQueryPage().save(filterQ, onSuccess, onError);

      function onSuccess(data) {
        // vm.links = ParseLinks.parse(headers('link'));
        vm.totalItems = data.totalElements;
        vm.queryCount = data.totalElements;
        vm.paymentLogList = data.content;
        vm.isSearching = false;
        gotToTop();
        // vm.page = vm.filterQuery.page+1;
      }

      function onError(error) {
        vm.isSearching = false;
        AlertService.error(error.data.message);
      }
    }
    function gotToTop() {
      // window.scroll(0, 0);
      if (vm.page > 1) {
        document.getElementsByClassName("topOfList")[0].scrollIntoView();
        document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
      }
    }
    function filterPaymentLogInfo_Global() {
      vm.filterQuery.searchMode = true;
      filterCompanyPaymentLogsInfo();
      clear();
    }
    function transition() {
      // $state.transitionTo($state.$current, {
      //     page: vm.page,
      //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
      //     search: vm.currentSearch
      // });
      if (vm.filterQuery.searchMode) getPaymentLogsPagesByQuery(vm.filterQuery);
      else getPaymentLogsPagesByQuery();
    }
    vm.findStatusStyle = function (status) {
      return "company-payment-log-status-" + status;
    };
    vm.findStatusIcon = function(status) {
            if (status == "DENIED") {
                return "glyphicon glyphicon-remove-sign";
            }
            if (status == "APPROVED") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "CHECKING") {
                return "glyphicon glyphicon-eye-open";
            }

        }
    vm.determinStatus = function (paymentLog) {
      $uibModal.open({
          templateUrl:"app/entities/company-payment-log/determin-status-dialog.html",
          controller: "DeterminStatusPaymentController",
          controllerAs: "vm",
          backdrop: "static",
          size: "lg",
          windowClass: "pl-modal",
          resolve: {
            entity: function() {
              return {
                paymentLog: paymentLog,
              }
            },
          },
        }).result.then(function (v) {
          loadAll()
         },
          function () {
            
          });
    };
    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = "id";
      vm.reverse = true;
      vm.currentSearch = null;
      vm.filterQuery.page = 0;
      vm.transition();
    }
    function pageSizeChanged() {
      QueryParamsService.updateFilter("size", vm.size);
      clearSearch();
    }
    function countFilters() {
      vm.filterCount = 0;

      if (vm.filterQuery["from-date"]) vm.filterCount++;
      if (vm.filterQuery["to-date"]) vm.filterCount++;
      if (vm.filterQuery["order-bag-id"]) vm.filterCount++;
      if (vm.filterQuery["approval-status"] && vm.filterQuery["approval-status"].length > 0) vm.filterCount++;
      if (vm.filterQuery["invoice-id"]) vm.filterCount++;
      if (vm.filterQuery["payment-type"] && vm.filterQuery["payment-type"].length > 0)
        vm.filterCount++;
      if (vm.filterCount < 1) QueryParamsService.removeFilter("filterQuery");
    }
    //Filter Dialog
    var ShowFilterDialogController = function ($scope,$mdDialog,dialogData,$mdSelect) {
      var $ctrl = this;
      $ctrl.data = dialogData;
      $ctrl.okModal = okModal;
      $ctrl.closeModal = closeModal;
      $ctrl.clearFilter = clearFilter;

      //for closing the select box
      document.body.onclick = function (e) {
        $mdSelect.hide();
      };

      function okModal() {
        $mdDialog.hide($ctrl.data);
      }

      function closeModal() {
        $mdDialog.cancel();
      }

      function clearFilter() {
        $ctrl.data.filterQuery = {};
      }
    };
    ShowFilterDialogController.$inject = ["$scope","$mdDialog","dialogData","$mdSelect"];
    vm.showFilterDialog = function () {
      var dialogData_ = {};
      dialogData_.statusList = ["CHECKING", "APPROVED", "DENIED"];
      dialogData_.filterQuery = vm.filterQuery;

      $mdDialog.show({
          locals: { dialogData: dialogData_ },
          controller: ShowFilterDialogController,
          templateUrl:"app/entities/company-payment-log/filter-payment-log-list-dialog.html",
          controllerAs: "$ctrl",
          parent: angular.element(document.body),
          targetEvent: dialogData_,
          clickOutsideToClose: true,
          size: "lg",
          fullscreen: false,
        })
        .then(function (data) {
            vm.filterQuery = {};
            setFilterQuery(data.filterQuery, true);
            QueryParamsService.updateFilter("filterQuery", encodeURIComponent(JSON.stringify(data.filterQuery)));
            vm.advancedSearch();
          })
    };
    function clearSearch() {
      QueryParamsService.removeFilter("query");
      vm.filterQuery.query = null;
      filterPaymentLogInfo_Global();
    }
    vm.advancedSearch = function () {
      QueryParamsService.updateFilter("query", vm.filterQuery.query);
      clear();
      vm.filterQuery.searchMode = true;
      filterCompanyPaymentLogsInfo();
    };
    function searchKeyPress(keyEvent) {
      if (keyEvent.which === 13) {
        vm.advancedSearch();
      }
    }

    function setFilterQuery(filter, ignorQuery) {
      var shallowFilter = filter;
      if (ignorQuery && shallowFilter.query) delete shallowFilter.query;
      angular.extend(vm.filterQuery, filter);
      countFilters();
    }
  }
})();


